import { render, staticRenderFns } from "./addCaseGoods.vue?vue&type=template&id=28a197bf&scoped=true&"
import script from "./addCaseGoods.vue?vue&type=script&lang=js&"
export * from "./addCaseGoods.vue?vue&type=script&lang=js&"
import style0 from "./addCaseGoods.vue?vue&type=style&index=0&id=28a197bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a197bf",
  null
  
)

export default component.exports